/**
 * Header
 *
 * @module header
 */

const component = {

    /**
     * Init component
     * 
     * @return {boolean|undefined}
     */
	init: () => {
        if(document.querySelector(".alert-message")) {
            document.body.classList.add('alert-message-on');

            if(document.querySelector(".alert-message__subtitle")) {
                document.body.classList.add('alert-message-subtitle');
            }
        }

        component.target = document.querySelector('.site-header');

        if (!component.target)
            return false;

        component.initEvents();
	},

     /**
     * Init Events
     * 
     * @return {undefined}
     */

    initEvents: () => {

        if(document.body.classList.contains('template-product')) {
            const galleryImages = document.querySelectorAll('.gallery__images img');


            if (galleryImages.length > 1 && window.screenMode != 'mobile') {
                
                let firstTrue = false;

                galleryImages.forEach((img, index) => {
                    let rect = img.getBoundingClientRect();

                    if ((rect.bottom > 0 && rect.bottom < rect.height) && !firstTrue) {
                        component.handleImageColor(img);
                        firstTrue = true;

                        if(index > 0){
                            window.scrollTo({
                                top: ((rect.height * index) + 16),
                                behavior: 'smooth'
                            });
                        }  
                        
                    } 
                });

                let lastScrollTop = 0;

                window.addEventListener('scroll', () => {
                    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    let isScrollingDown = scrollTop > lastScrollTop;
                    lastScrollTop = scrollTop;
        
                    galleryImages.forEach((img) => {
                        let rect = img.getBoundingClientRect();

                        if ((isScrollingDown && (rect.top > -90 && rect.top < 0 )) || 
                            (!isScrollingDown && (rect.bottom > 0 &&  rect.bottom < 90))) {
                            component.handleImageColor(img);
                        }
                    });
                });
              } else {
                const img = document.querySelector('.gallery__images img');
                component.handleImageColor(img);
              }
        } else {
            const img = document.querySelector('.event-detail__image img');

            if (img) {
                component.getColorFromImage(img.src).then(color => {
                    let rgb = color.match(/\d+/g).map(Number);
                    let yiq = ((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000;
                    let isDarkColor = (parseInt(yiq) < 128) ? true : false;
                            
                    if (isDarkColor) {
                        document.body.classList.add('light-text');
                    } 
                });
            }
        }

        let scrollPosition = window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition > 109) {
            component.target.classList.add("sticky");
            document.body.classList.add("menu-sticky");
        } else if (scrollPosition < 56) {
            component.target.classList.remove("sticky");
            document.body.classList.remove("menu-sticky");
        }

        window.addEventListener('scroll', () => {
            scrollPosition = window.scrollY || document.documentElement.scrollTop;

            if (scrollPosition > 109) {
                component.target.classList.add("sticky");
                document.body.classList.add("menu-sticky");
            } else if (scrollPosition < 56) {
                component.target.classList.remove("sticky");
                document.body.classList.remove("menu-sticky");
            }
        });

    },

    getColorFromImage: (imageUrl) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.crossOrigin = 'Anonymous';
            image.src = imageUrl;
            image.onload = () => {
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d');
              const width = image.width;
              const height = Math.min(image.height, 90); 
              canvas.width = width;
              canvas.height = height;
              context.drawImage(image, 0, 0, width, height);
              const data = context.getImageData(0, 0, width, height).data;
              
              let r = 0, g = 0, b = 0;
              const pixelCount = width * height;
              for (let i = 0; i < data.length; i += 4) {
                r += data[i];
                g += data[i + 1];
                b += data[i + 2];
              }
              r = Math.round(r / pixelCount);
              g = Math.round(g / pixelCount);
              b = Math.round(b / pixelCount);
      
              resolve(`rgb(${r}, ${g}, ${b})`);
            };
            image.onerror = reject;
        });
    },

    handleImageColor: (img) => {
        component.getColorFromImage(img.src).then(color => {
          let rgb = color.match(/\d+/g).map(Number);
          let yiq = ((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000;
          let isDarkColor = parseInt(yiq) < 128;
    
          if (isDarkColor) {
            document.body.classList.add('light-text');
          } else {
            document.body.classList.remove('light-text');
          }
        }).catch(err => {
          console.error('Error getting image color:', err);
        });
    }
};

export default component;
